import { Injectable, Injector } from '@angular/core';
import { isEqual, noop } from '@sama/micro-dash';
import { KeyboardShortcutService } from '../../../../cross-team-shared/misc-services/keyboard-shortcut.service';
import { EventTrackingValueWithSource } from '../../../../cross-team-shared/misc-utils';
import { toolsConfig } from '../../../../cross-team-shared/tools.config';
import { ViewBoxService } from '../../utils/view-box.service';
import { AbstractTool2D } from '../shared/abstract-tool-2d';
import { OverlayRectangleDragHandler } from '../shared/drag-handlers/overlay-rectangle-drag-handler';
import { ZoomSecondaryToolbarComponent } from './zoom-secondary-toolbar.component';

export const ZOOM_PANEL_FACTOR = 1.1;

@Injectable()
export class ZoomTool extends AbstractTool2D {
  readonly name = toolsConfig.Zoom.name;
  override secondaryToolbarType = ZoomSecondaryToolbarComponent;

  constructor(
    private viewBoxService: ViewBoxService,
    injector: Injector,
    keyboardShortcutService: KeyboardShortcutService,
  ) {
    super(injector);

    this.subscribeTo(
      keyboardShortcutService.getMatchingEvent$('resetSensorView'),
      ({ eventTrackingValue }) => {
        this.resetZoom(eventTrackingValue);
      },
    );
  }

  override async onActivate() {
    await super.onActivate();
    this.onEvent('container', 'mousedown', this.startZoomRectangle);
  }

  zoom(direction: 'in' | 'out', source: 'zoom_in_button' | 'zoom_out_button') {
    void this.viewBoxService.zoomToCenter(direction, source);
  }

  resetZoom(eventTrackingValueWithSource: EventTrackingValueWithSource) {
    this.viewBoxService.resetZoom(eventTrackingValueWithSource);
  }

  openZoomPanel() {
    this.shellConnector.toggleZoomPanel();
  }

  private startZoomRectangle(event: MouseEvent) {
    const initialImagePoint = this.getImagePoint();
    const dragHandler = new OverlayRectangleDragHandler(
      event,
      this.injector,
      false,
    );
    dragHandler.completion.then(() => {
      const finalImagePoint = this.getImagePoint();
      if (!isEqual(initialImagePoint, finalImagePoint)) {
        void this.viewBoxService.zoomToBox(
          [initialImagePoint, finalImagePoint],
          'zoom_rectangle',
        );
      }
    }, noop); // `noop` suppresses an "unhandled rejection" error

    this.registerHelper(dragHandler);
  }
}
